export default "__VITE_ASSET__DTIn3brx__"